// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Grid Layout UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
:root {
  /* ezClocker Font Famlies */
  --ezLayoutGrid-row-label-font-size: 12pt;
}

/* -------------------------------------------------------------------
| Page Grid Layout Styles
------------------------------------------------------------------- */
.ezHtml {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
}

.ezPageHeader {
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
}

.ezFixedPageHeader {
  position: fixed;
  top: 0;
  width: 100%;
}

.ezPageBody {
  display: grid;
  align-content: start;
  margin: var(--ezBodyMarginSize);
  padding: var(--ezBodyPaddingSize);
  background-color: var(--ezAlphaBackgroundWhite1);
  background-size: var(--ezBackgroundImageSize);
  background-image: var(--ezBackgroundImage);
  color: var(--ezContentFontColor);
  font-size: var(--ezContentFontSize);
  font-family: var(--ezFontFamily);
  font-weight: var(--ezContentFontWeight);
  font-style: var(--ezContentFontStyle);
}

.ezPageBody-no-scroll {
  display: grid;
  align-content: start;
  margin: var(--ezBodyMarginSize);
  padding: var(--ezBodyPaddingSize);
  background-color: var(--ezAlphaBackgroundWhite1);
  background-size: var(--ezBackgroundImageSize);
  background-image: var(--ezBackgroundImage);
  color: var(--ezContentFontColor);
  font-size: var(--ezContentFontSize);
  font-family: var(--ezFontFamily);
  font-weight: var(--ezContentFontWeight);
  font-style: var(--ezContentFontStyle);
  overflow: hidden;
}

.ezPageView {
  display: grid;
  margin: 0;
  padding: 0;
  align-content: start;
  background-color: transparent;
}

.ezPageView-no-scroll {
  display: grid;
  margin: 0;
  padding: 0;
  align-content: start;
  background-color: transparent;
  overflow: hidden;
}

.ezPageViewHeader {
  display: grid;
  align-content: start;
  grid-template-columns: 100%;
  background-color: transparent;
  overflow: hidden;
}

.ezPageSection {
  display: grid;
  padding: 0;
  margin: 0;
  align-content: start;
  grid-template-columns: 100%;
  background-color: transparent;
  overflow: hidden;
}

.ezContentView {
  margin-top: 4px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 0;
  background-color: transparent;
  overflow: auto;
}

.ezContentSection {
  margin: 0;
  padding: 0;
  background-color: transparent;
}

.ezContentSection-vertical-scroll {
  margin: 0;
  padding: 0;
  background-color: transparent;
  overflow-y: scroll;
  overflow-x: hidden;
}

.ezContent-grid-col-section-50x50 {
  display: grid;
  margin: 0;
  padding: 0;
  grid-row-gap: 0;
  grid-column-gap: 4px;
  grid-template-columns: 50% 50%;
  background-color: transparent;
}

.ezContentSection-inset-border-2-radius-bottom-pad4-vscroll {
  margin: 0;
  padding: 4px;
  background-color: transparent;
  overflow-y: scroll;
  overflow-x: hidden;
  border-color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 2px;
  border-radius: 3px;
}

.ezSubContentView {
  display: grid;
  padding: 8px;
  align-content: stretch;
  justify-content: stretch;
  background-color: var(--ezClockerWhite);
  color: var(--ezFontColor);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
  border-color: var(--ezClockerSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezSubContentView-no-scroll {
  background-color: var(--ezClockerWhite);
  color: var(--ezFontColor);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
  border-color: var(--ezClockerSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  overflow: hidden;
}

.ezSubContentView_vertical {
  padding: 8px;
  background-color: var(--ezClockerWhite);
  color: var(--ezFontColor);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
  border-color: var(--ezClockerSilver);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

.ezSubContentView-no-border {
  padding: 8px;
  background-color: var(--ezClockerWhite);
  color: var(--ezFontColor);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
  border-style: none;
}

.ezSubContentView-no-border-no-scroll {
  background-color: var(--ezClockerWhite);
  color: var(--ezFontColor);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
  border-style: none;
  overflow: hidden;
}

.ezSubContentView-transparent-no-border-no-scroll {
  background-color: transparent;
  color: var(--ezFontColor);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
  border-style: none;
  overflow: hidden;
}

/*
    @deprecated
    Migrate to ezHtml, ezPageBody, ezPageView functionality
*/
.ezPage {
  display: grid;
  align-content: stretch;
  justify-content: stretch;
  grid-template-columns: auto;
  grid-template-rows: auto;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

/*
    @deprecated
    Migrate to ezHtml, ezPageBody, ezPageView, ezPageContent functionality
*/
.ezContent {
  display: grid;
  align-content: stretch;
  justify-content: stretch;
  grid-template-columns: auto;
  grid-template-rows: auto;
  margin-top: 4px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 0;
  overflow: scroll;
}

/* -------------------------------------------------------------------
| Specific Grid Styles
------------------------------------------------------------------- */
.ezTimeEntryGridContainer {
  display: grid;
  align-content: stretch;
  justify-content: stretch;
  grid-template-columns: auto;
  grid-template-rows: auto;
  padding: 8px;
  margin-top: 10px;
  background-color: var(--ezAlphaBackgroundWhite2);
}

/* -------------------------------------------------------------------
| Generic Top Level Grid Styles
------------------------------------------------------------------- */
.ezFullScreen {
  display: grid;
  width: 100%;
  height: 100%;
}

.ezGridX {
  display: grid;
  color: var(--ezFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
}

.ezGridHeader {
  display: grid;
  padding: 6px;
  color: var(--ezTopicFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezTopicFontSize);
  font-weight: var(--ezTopicFontWeight);
  font-style: var(--ezTopicFontStyle);
}

.ezGridHeader-navy {
  display: grid;
  justify-content: start;
  align-content: center;
  background-color: var(--ezClockerNavy);
  color: var(--ezTopicFontColorWhite);
  font-size: var(--ezTopicFontSize);
  font-weight: var(--ezTopicFontWeight);
  font-style: var(--ezTopicFontStyle);
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
}

.ezGridContent {
  display: grid;
  padding: 4px;
  color: var(--ezContentFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezContentFontSize);
  font-weight: var(--ezContentFontWeight);
  font-style: var(--ezContentFontStyle);
}

.ezGridFullPage {
  display: grid;
  height: 100%;
}

.ezRowItem-container_2Col {
  display: grid;
  grid-template-columns: max-content auto;
  justify-content: stretch;
  align-content: center;
  grid-column-gap: 4px;
  grid-row-gap: 0;
  padding: 8px;
  background-color: var(--ezClockerWhite);
  color: var(--ezFontColor);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezTopicFontStyle);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 2px;
}

.ezRowItem-container-disabled_2Col {
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerStone);
  border-color: var(--ezClockerStone);
}

.ezRowItem-container-archived_2Col {
  display: grid;
  grid-template-rows: none;
  justify-content: stretch;
  align-content: center;
  grid-column-gap: 4px;
  grid-row-gap: 0;
  padding: 8px;
  background-color: var(--ezClockerGray);
  color: var(--ezClockerWhite);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezTopicFontStyle);
  border-color: var(--ezBorderGray);
  border-style: solid;
  border-width: 1px;
}

.ezRowItem-text_col-1of2 {
  display: grid;
  grid-column: 1/2;
  grid-row: 1;
  justify-content: start;
  align-content: center;
}

.ezRowItem-button-container_col-2of2 {
  display: grid;
  grid-template-columns: auto auto;
  grid-column: 2/2;
  grid-row: 1;
  justify-content: end;
  align-content: center;
}

/* -------------------------------------------------------------------
| Grid Row and Column Gap Styles
------------------------------------------------------------------- */
.ezGridNoGap {
  display: grid;
  grid-row-gap: 0;
  grid-column-gap: 0;
}

.ezGridGap {
  display: grid;
  grid-row-gap: 2px;
  grid-column-gap: 2px;
}

.ezGridGap_2 {
  display: grid;
  grid-row-gap: 2px;
  grid-column-gap: 2px;
}

.ezGridGap_4 {
  display: grid;
  grid-row-gap: 4px;
  grid-column-gap: 4px;
}

.ezGridGap_8 {
  display: grid;
  grid-row-gap: 8px;
  grid-column-gap: 8px;
}

.ezGridGap_20 {
  display: grid;
  grid-row-gap: 20px;
  grid-column-gap: 20px;
}

.ezGrid-col-gap-4 {
  display: grid;
  grid-column-gap: 4px;
}

.ezGrid-col-gap_6 {
  display: grid;
  grid-column-gap: 6px;
}

.ezGrid-col-gap_8 {
  display: grid;
  grid-column-gap: 8px;
}

.ezGrid-no-row-gap {
  display: grid;
  grid-row-gap: 0;
}

.ezGrid-row-gap_8 {
  display: grid;
  grid-row-gap: 8px;
}

.ezGrid-row-gap_10 {
  display: grid;
  grid-row-gap: 10px;
}

.ezGrid-row-gap-0 {
  display: grid;
  grid-row-gap: 0;
}

/* -------------------------------------------------------------------
| Grid Text Styles
------------------------------------------------------------------- */
.ezGridContentText {
  color: var(--ezContentFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezContentFontSize);
  font-weight: var(--ezContentFontWeight);
  font-style: var(--ezContentFontStyle);
}

.ezGridRowLabelText {
  color: var(--ezFontColor);
  font-family: var(--ezFontFamily);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
  font-size: var(--ezLayoutGrid-row-label-font-size);
}

.ezGridNormalText {
  color: var(--ezFontColor);
  font-family: var(--ezFontFamily);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
}

.ezGridTopicText {
  color: var(--ezClockerWhite);
  font-family: var(--ezFontFamily);
  font-size: var(--ezTopicFontSize);
  font-weight: var(--ezTopicFontWeight);
  font-style: var(--ezTopicFontStyle);
}

/* -------------------------------------------------------------------
| Grid Background Styles
------------------------------------------------------------------- */
.ezGridWhite {
  background-color: var(--ezClockerWhite);
  color: var(--ezContentFontColor);
  border-radius: 3px;
}

.ezGridBlack {
  background-color: var(--ezClockerBlack);
  color: var(--ezClockerWhite);
  border-radius: 3px;
}

.ezGridNavy {
  background-color: var(--ezNavy);
  color: var(--ezNavyContainerTextColor);
  border-radius: 3px;
}

.ezGridGray {
  background-color: var(--ezGray);
  color: var(--ezGrayContainerText);
  border-radius: 3px;
}

.ezGridStone {
  background-color: var(--ezClockerStone);
  color: var(--ezContentFontColor);
  border-radius: 3px;
}

.ezGridYellow {
  background-color: var(--ezYellow);
  color: var(--ezYelloContainerText);
  border-radius: 3px;
}

/* -------------------------------------------------------------------
| Grid Horizontal Alignment Styles (X-Axis)
------------------------------------------------------------------- */
.ezGrid-align-left {
  display: grid;
  /* X-Axis */
  justify-content: start;
}

.ezGrid-align-center {
  display: grid;
  /* X-Axis */
  justify-content: center;
}

.ezGrid-align-right {
  display: grid;
  /* X-Axis */
  justify-content: end;
}

.ezGrid-align-full {
  display: grid;
  /* X-Axis */
  justify-content: stretch;
}

.ezGrid-align-space-between {
  display: grid;
  /* X-Axis */
  justify-content: space-between;
}

.ezGrid-align-space-around {
  display: grid;
  /* X-Axis */
  justify-content: space-around;
}

.ezGrid-align-space-evenly {
  display: grid;
  /* X-Axis */
  justify-content: space-evenly;
}

/* -------------------------------------------------------------------
| Grid Vertical Alignment Styles (Y-Axis)
------------------------------------------------------------------- */
.ezGrid-vertical-align-top {
  display: grid;
  /* Y-Axis */
  align-content: start;
}

.ezGrid-vertical-align-middle {
  display: grid;
  /* Y-Axis */
  align-content: center;
}

.ezGrid-vertical-align-bottom {
  display: grid;
  /* Y-Axis */
  align-content: end;
}

.ezGrid-vertical-align-full {
  display: grid;
  /* Y-Axis */
  align-content: stretch;
}

.ezGrid-vertical-space-evenly {
  display: grid;
  /* Y-Axis */
  align-content: space-evenly;
}

.ezGrid-vertical-space-between {
  display: grid;
  /* Y-Axis */
  align-content: space-between;
}

/* -------------------------------------------------------------------
| Grid Vertical and Horizontal Alignment Styles
------------------------------------------------------------------- */
.ezGrid-fullsize {
  display: grid;
  /* X-Axis */
  align-content: stretch;
  /* Y-Axis */
  justify-content: stretch;
}

.ezGrid-align-top-left {
  display: grid;
  /* X-Axis */
  align-content: start;
  /* Y-Axis */
  justify-content: start;
}

.ezGrid-align-fullsize {
  display: grid;
  /* X-Axis */
  align-content: stretch;
  /* Y-Axis */
  justify-content: stretch;
}

.ezGrid-align-middle-full-width {
  display: grid;
  /* X-Axis */
  align-content: stretch;
  /* Y-Axis */
  justify-content: center;
}

.ezGrid-align-middle-left {
  display: grid;
  /* X-Axis */
  align-content: center;
  /* Y-Axis */
  justify-content: start;
}

.ezGrid-align-middle-right {
  display: grid;
  /* X-Axis */
  align-content: center;
  /* Y-Axis */
  justify-content: end;
}

.ezGrid-align-middle-center {
  display: grid;
  /* X-Axis */
  align-content: center;
  /* Y-Axis */
  justify-content: center;
}

.ezGrid-align-top-space-evenly {
  display: grid;
  /* X-Axis */
  align-content: start;
  /* Y-Axis */
  justify-content: space-between;
}

.ezGrid-x-space-between-y-stretch {
  display: grid;
  /* X-Axis */
  align-content: center;
  /* Y-Axis */
  justify-content: space-evenly;
}

/* -------------------------------------------------------------------
| Columns Classes for 2 Column Grids
------------------------------------------------------------------- */
.ezCol-1of2 {
  display: grid;
  grid-column: 1/2;
}

.ezCol-2of2 {
  display: grid;
  grid-column: 2/2;
}

/* -------------------------------------------------------------------
| Columns Classes for 3 Column Grids
------------------------------------------------------------------- */
.ezCol-1of3 {
  display: grid;
  grid-column: 1/2;
}

.ezCol-2of3 {
  display: grid;
  grid-column: 2/2;
}

.ezCol-3of3 {
  display: grid;
  grid-column: 3/3;
}

/* -------------------------------------------------------------------
| Columns Classes for 4 Column Grids
------------------------------------------------------------------- */
.ezCol-1of4 {
  display: grid;
  grid-column: 1/4;
}

.ezCol-2of4 {
  display: grid;
  grid-column: 2/4;
}

.ezCol-3of4 {
  display: grid;
  grid-column: 3/4;
}

.ezCol-4of4 {
  display: grid;
  grid-column: 3/4;
}

/* -------------------------------------------------------------------
| Generic Row Grid Styles
------------------------------------------------------------------- */
.ezAutoRow {
  display: grid;
  grid-template-rows: auto;
}

.ezAutoRow_Min {
  display: grid;
  grid-template-rows: min-content;
}

.ezAutoRow_100 {
  display: grid;
  grid-template-rows: 100%;
}

/* -------------------------------------------------------------------
| Two Row Grid Styles
------------------------------------------------------------------- */
.ezAutoRow_Min_2 {
  display: grid;
  grid-template-rows: min-content min-content;
}

.ezAutoRow_Min_Auto {
  display: grid;
  grid-template-rows: min-content auto;
}

.ezAutoRow_MinxMax,
.ezAutoRow_Min_Max {
  display: grid;
  grid-template-rows: min-content max-content;
}

.ezAutoRow_600px_600px {
  display: grid;
  grid-template-columns: 600px 600px;
}

.ezAutoRow_Min_Min {
  display: grid;
  grid-template-rows: min-content min-content;
}

.ezAutoRow_A_Max {
  display: grid;
  grid-template-rows: auto max-content;
}

.ezAutoRow_A_min {
  display: grid;
  grid-template-rows: auto min-content;
}

.ezAutoRow_AxA,
.ezAutoRow_A_A {
  display: grid;
  grid-template-rows: auto auto;
}

.ezAutoRow_50_A {
  display: grid;
  grid-template-rows: 50% auto;
}

.ezAutoRow_A_50 {
  display: grid;
  grid-template-rows: auto 50%;
}

.ezAutoRow_50x50,
.ezAutoRow_50_50 {
  display: grid;
  grid-template-rows: 50% 50%;
}

/* -------------------------------------------------------------------
| Three Row Grid Styles
------------------------------------------------------------------- */
.ezAutoRow_Min_3 {
  display: grid;
  grid-template-rows: min-content min-content min-content;
}

.ezAutoRow_A_A_A {
  display: grid;
  grid-template-rows: auto auto auto;
}

.ezAutoRow_33_A_33 {
  display: grid;
  grid-template-rows: 33% auto 33%;
}

.ezAutoRow_33_33_33 {
  display: grid;
  grid-template-rows: 33% 33% 33%;
}

.ezAutoRow_33_33_A {
  display: grid;
  grid-template-rows: 33% 33% auto;
}

.ezAutoRow_A_33_33 {
  display: grid;
  grid-template-rows: auto 33% 33%;
}

.ezAutoRow_25_A_25 {
  display: grid;
  grid-template-rows: 25% auto 25%;
}

.ezAutoRow_25_50_25 {
  display: grid;
  grid-template-rows: 25% 50% 25%;
}

.ezAutoRow_25_25_A {
  display: grid;
  grid-template-rows: 25% 25% auto;
}

.ezAutoRow_A_25_25 {
  display: grid;
  grid-template-rows: auto 25% 25%;
}

.ezAutoRow_1fr_2fr_1fr {
  display: grid;
  grid-template-rows: 1fr 2fr 1fr;
}

.ezAutoRow_Min_Max_A {
  display: grid;
  grid-template-rows: min-content, max-content, auto;
}

/* -------------------------------------------------------------------
| Four Row Grid Styles
------------------------------------------------------------------- */
.ezAutoRow_AxAxAxA {
  display: grid;
  grid-template-rows: auto auto auto auto;
}

/* -------------------------------------------------------------------
| Five Row Grid Styles
------------------------------------------------------------------- */
.ezAutoRow_AxAxAxAxA {
  display: grid;
  grid-template-rows: auto auto auto auto auto;
}

/* -------------------------------------------------------------------
| One Column Grid Styles
------------------------------------------------------------------- */
.ezAutoCol_A {
  display: grid;
  grid-template-columns: auto;
}

.ezAutoCol_100 {
  display: grid;
  grid-template-columns: 100%;
}

.ezAutoCol_99 {
  display: grid;
  grid-template-columns: 99%;
}

/* -------------------------------------------------------------------
| Two (TWO! HA HA HA!) Column Grid Styles
------------------------------------------------------------------- */
.ezAutoCol_83xA {
  grid-template-columns: 83.33333333% auto;
}

.ezAutoCol_MinxA {
  display: grid;
  grid-template-columns: min-content auto;
}

.ezAutoCol_AxMin {
  display: grid;
  grid-template-columns: auto min-content;
}

.ezAutoCol_AxMax {
  display: grid;
  grid-template-columns: auto max-content;
}

.ezAutoCol_MinxMax {
  display: grid;
  grid-template-columns: min-content max-content;
}

.ezAutoCol_Max_Min {
  display: grid;
  grid-template-columns: max-content min-content;
}

.ezAutoCol_Max_A {
  display: grid;
  grid-template-columns: max-content min-content;
}

.ezAutoCol_Max_Max {
  display: grid;
  grid-template-columns: max-content max-content;
}

.ezAutoCol_AxA {
  display: grid;
  grid-template-columns: auto auto;
}

.ezAutoCol_50xA {
  display: grid;
  grid-template-columns: 50% auto;
}

.ezAutoCol_Ax70 {
  display: grid;
  grid-template-columns: auto 70%;
}

.ezAutoCol_Ax50 {
  display: grid;
  grid-template-columns: auto 50%;
}

.ezAutoCol_50x50 {
  display: grid;
  grid-template-columns: 50% 50%;
}

.ezAutoCol_200PXxA {
  display: grid;
  grid-template-columns: 200px auto;
}

.ezAutoCol_33xA {
  display: grid;
  grid-template-columns: 33% auto;
}

.ezAutoCol_Ax33 {
  display: grid;
  grid-template-columns: auto 33%;
}

.ezAutoCol_25xA {
  display: grid;
  grid-template-columns: 25% auto;
}

.ezAutoCol_Ax25 {
  display: grid;
  grid-template-columns: auto 25%;
}

.ezAutoCol_75xA {
  display: grid;
  grid-template-columns: 75% auto;
}

/* -------------------------------------------------------------------
| Three (THREE! HA HA HA!) Column Grid Styles
------------------------------------------------------------------- */
.ezAutoCol_28px_28px_28px {
  display: grid;
  grid-template-columns: 28px 28px 28px;
}

.ezAutoCol_MinxMinxMin {
  display: grid;
  grid-template-columns: min-content min-content min-content;
}

.ezAutoCol_AxAxMin {
  display: grid;
  grid-template-columns: auto auto min-content;
}

.ezAutoCol_AxAxA {
  display: grid;
  grid-template-columns: auto auto auto;
}

.ezAutoCol_25x25xA {
  display: grid;
  grid-template-columns: 25% 25% auto;
}

.ezAutoCol_25xAx25 {
  display: grid;
  grid-template-columns: 25% auto 25%;
}

.ezAutoCol_Ax25x25 {
  display: grid;
  grid-template-columns: auto 25% 25%;
}

.ezAutoCol_33x33xA {
  display: grid;
  grid-template-columns: 33% 33% auto;
}

.ezAutoCol_33xAx33 {
  display: grid;
  grid-template-columns: 33% auto 33%;
}

.ezAutoCol_Ax33x33 {
  display: grid;
  grid-template-columns: auto 33% 33%;
}

.ezAutoCol_33x33x33 {
  display: grid;
  grid-template-columns: 33% 33% 33%;
}

.ezAutoCol_50x25xA {
  display: grid;
  grid-template-columns: 25% 25% auto;
}

.ezAutoCol_Ax50x25 {
  display: grid;
  grid-template-columns: auto 50% 25%;
}

.ezAutoCol_50xAx25 {
  display: grid;
  grid-template-columns: 50% auto 25%;
}

.ezAutoCol_50xAxA {
  display: grid;
  grid-template-columns: 50% auto auto;
}

.ezAutoCol_Ax50xA {
  display: grid;
  grid-template-columns: auto 50% auto;
}

.ezAutoCol_AxAx50 {
  display: grid;
  grid-template-columns: auto auto 50%;
}

.ezAutoCol_AxAx30px {
  display: grid;
  grid-template-columns: auto auto 33px;
}

/* -------------------------------------------------------------------
| Four (FOUR! HA HA HA!) Column Grid Styles
------------------------------------------------------------------- */
.ezAutoCol_AxAxAxA {
  display: grid;
  grid-template-columns: auto auto auto auto;
}

.ezAutoCol_25x25xAxA {
  display: grid;
  grid-template-columns: 25% 25% auto auto;
}

.ezAutoCol_25x25x25xA {
  display: grid;
  grid-template-columns: 25% 25% 25% auto;
}

.ezAutoCol_25xAxAx25 {
  display: grid;
  grid-template-columns: 25% auto auto 25%;
}

.ezAutoCol_AxAxAx25 {
  display: grid;
  grid-template-columns: auto auto auto 25%;
}

.ezAutoCol_10xAxAx10 {
  display: grid;
  grid-template-columns: 10% auto auto 10%;
}

.ezAutoCol_AxAxAxMax {
  display: grid;
  grid-template-columns: auto auto auto max-content;
}

/* -------------------------------------------------------------------
| Five (FIVE! MUHAHAHAHA!) Column Grid Styles
------------------------------------------------------------------- */
.ezAutoCol_AxAxAxAxA {
  display: grid;
  grid-template-columns: auto auto auto auto auto;
}

/* Column Spans */
.ezColSpan_1a2 {
  display: grid;
  grid-column-start: 1;
  grid-column-end: 2;
}

.ezColSpan_1a2a3 {
  display: grid;
  grid-column-start: 1;
  grid-column-end: 3;
}

.ezColSpan_2a3 {
  display: grid;
  grid-column-start: 2;
  grid-column-end: 3;
}

/* -------------------------------------------------------------------
| Sub-Grid Styles
------------------------------------------------------------------- */
.ezSubGridColRow {
  display: grid;
  grid-template-columns: subgrid;
  grid-template-rows: subgrid;
}

.ezSubgridRow {
  display: grid;
  grid-template-rows: subgrid;
}

.ezSubGridCol {
  display: grid;
  grid-template-columns: subgrid;
}

/* Grid Column Gaps */
.ezNoGridColumnGap {
  display: grid;
  grid-column-gap: 0;
  column-gap: 0;
}

/* -------------------------------------------------------------------
| Grid Column Gap Styles
------------------------------------------------------------------- */
.ezGridColumnGap {
  display: grid;
  grid-column-gap: 1px;
  column-gap: 1px;
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1024px) {
}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 768px) {
}
*/
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 480px) {
}/

/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 319px) {
}
*/
/* -------------------------------------------------------------------
| DEPRECATED STYLES
------------------------------------------------------------------- */
/* DEPRECATED */
.ezPadTop2 {
  padding-top: 2px;
}

/* DEPRECATED */
.ezPadBottom2 {
  padding-bottom: 2px;
}

/* DEPRECATED */
.ezPadTopBottom2 {
  padding-top: 2px;
  padding-bottom: 2px;
}

/* DEPRECATED */
.ezPadLeft2 {
  padding-left: 2px;
}

/* DEPRECATED */
.ezPadRight2 {
  padding-right: 2px;
}

/* DEPRECATED */
.ezPadLeftRight2 {
  padding-left: 2px;
  padding-right: 2px;
}

/* DEPRECATED */
.ezPaddedBox4 {
  padding: 4px;
}

/* DEPRECATED */
.ezPadTop4 {
  padding-top: 4px;
}

/* DEPRECATED */
.ezPadBottom4 {
  padding-bottom: 4px;
}

/* DEPRECATED */
.ezPadTopBottom4 {
  padding-top: 4px;
  padding-bottom: 4px;
}

/* DEPRECATED */
.ezPadLeft4 {
  padding-left: 4px;
}

/* DEPRECATED */
.ezPadRight4 {
  padding-right: 4px;
}

/* DEPRECATED */
.ezPadLeftRight4 {
  padding-left: 4px;
  padding-right: 4px;
}

/* DEPRECATED */
.ezPadTop6 {
  padding-top: 6px;
}

/* DEPRECATED */
.ezPadBottom6 {
  padding-bottom: 6px;
}

/* DEPRECATED */
.ezPadTopBottom6 {
  padding-top: 6px;
  padding-bottom: 6px;
}

/* DEPRECATED */
.ezPadLeft6 {
  padding-left: 6px;
}

/* DEPRECATED */
.ezPadRight6 {
  padding-right: 6px;
}

/* DEPRECATED */
.ezPadLeftRight6 {
  padding-left: 6px;
  padding-right: 6px;
}

/* DEPRECATED */
.ezPadTop8 {
  padding-top: 8px;
}

/* DEPRECATED */
.ezPadBottom8 {
  padding-bottom: 8px;
}

/* DEPRECATED */
.ezPadTopBottom8 {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* DEPRECATED */
.ezPadLeft8 {
  padding-left: 8px;
}

/* DEPRECATED */
.ezPadRight8 {
  padding-right: 8px;
}

/* DEPRECATED */
.ezPadLeftRight8 {
  padding-left: 8px;
  padding-right: 8px;
}

/* DEPRECATED */
.ezPadTop10 {
  padding-top: 10px;
}

/* DEPRECATED */
.ezPadBottom10 {
  padding-bottom: 10px;
}

/* DEPRECATED */
.ezPadTopBottom10 {
  padding-top: 10px;
  padding-bottom: 10px;
}

/* DEPRECATED */
.ezPadLeft10 {
  padding-left: 10px;
}

/* DEPRECATED */
.ezPadRight10 {
  padding-right: 10px;
}

/* DEPRECATED */
.ezPadLeftRight10 {
  padding-left: 10px;
  padding-right: 10px;
}

/* DEPRECATED */
.ezMargin2 {
  margin: 2px;
}

/* DEPRECATED */
.ezMarginTop2 {
  margin-top: 2px;
}

/* DEPRECATED */
.ezMarginBottom2 {
  margin-bottom: 2px;
}

/* DEPRECATED */
.ezMarginTopBottom2 {
  margin-top: 2px;
  margin-bottom: 2px;
}

/* DEPRECATED */
.ezMarginLeft2 {
  margin-left: 2px;
}

/* DEPRECATED */
.ezMarginRight2 {
  margin-right: 2px;
}

/* DEPRECATED */
.ezMarginLeftRight2 {
  margin-left: 2px;
  margin-right: 2px;
}

/* DEPRECATED */
.ezMargin4 {
  margin: 4px;
}

/* DEPRECATED */
.ezMarginTop4 {
  margin-top: 4px;
}

/* DEPRECATED */
.ezMarginBottom4 {
  margin-bottom: 4px;
}

/* DEPRECATED */
.ezMarginTopBottom4 {
  margin-top: 4px;
  margin-bottom: 4px;
}

/* DEPRECATED */
.ezMarginLeft4 {
  margin-left: 4px;
}

/* DEPRECATED */
.ezMarginRight4 {
  margin-right: 4px;
}

/* DEPRECATED */
.ezMarginLeftRight4 {
  margin-left: 4px;
  margin-right: 4px;
}

/* DEPRECATED */
.ezMargin8 {
  margin: 8px;
}

/* DEPRECATED */
.ezMarginTop8 {
  margin-top: 8px;
}

/* DEPRECATED */
.ezMarginBottom8 {
  margin-bottom: 8px;
}

/* DEPRECATED */
.ezMarginTopBottom8 {
  margin-top: 8px;
  margin-bottom: 8px;
}

/* DEPRECATED */
.ezMarginLeft8 {
  margin-left: 8px;
}

/* DEPRECATED */
.ezMarginRight8 {
  margin-right: 8px;
}

/* DEPRECATED */
.ezMarginLeftRight8 {
  margin-left: 8px;
  margin-right: 8px;
}

/* DEPRECATED */
.ezMargin10 {
  margin: 10px;
}

/* DEPRECATED */
.ezMarginTop10 {
  margin-top: 10px;
}

/* DEPRECATED */
.ezMarginBottom10 {
  margin-bottom: 10px;
}

/* DEPRECATED */
.ezMarginTopBottom10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

/* DEPRECATED */
.ezMarginLeft10 {
  margin-left: 10px;
}

/* DEPRECATED */
.ezMarginRight10 {
  margin-right: 10px;
}

/* DEPRECATED */
.ezMarginLeftRight10 {
  margin-left: 10px;
  margin-right: 10px;
}

/* -------------------------------------------------------------------
| Legacy Auto-Column (experimental) Styles
------------------------------------------------------------------- */
/* DEPRECATED */
.ezAutoCol1 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 8.33333333%;
}

/* DEPRECATED */
.ezAutoCol2 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 16.66666667%;
}

/* DEPRECATED */
.ezAutoCol3 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 25%;
}

/* DEPRECATED */
.ezAutoCol4 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 33.33333333%;
}

/* DEPRECATED */
.ezAutoCol5 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 41.66666667%;
}

/* DEPRECATED */
.ezAutoCol6 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 50%;
}

/* DEPRECATED */
.ezAutoCol7 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 58.33333333%;
}

/* DEPRECATED */
.ezAutoCol8 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 66.66666667%;
}

/* DEPRECATED */
.ezAutoCol9 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 75%;
}

/* DEPRECATED */
.ezAutoCol10 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 83.33333333%;
}

/* DEPRECATED */
.ezAutoCol11 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 91.66666667%;
}

/* DEPRECATED */
.ezColumn12 {
  display: grid;
  min-height: 1px;
  grid-template-columns: 100%;
}

/* DEPRECATED */
.ezCenterBox {
  display: flex;
  text-align: right;
  flex-direction: column;
  align-items: center;
}

/* DEPRECATED */
.ezBox {
  display: inline-block;
}

/* DEPRECATED */
.ezFooter {
  padding: 4px;
  height: 24px;
  bottom: 0;
  background-color: var(--ezClockerSilver);
}

/* DEPRECATED */
.ezRightAlign {
  text-align: right;
}

/* DEPRECATED */
td.ezclockerHeader2015Right {
  vertical-align: middle;
  text-align: right;
}

/* DEPRECATED */
.ezInfoBox {
  padding: 4px;
  background-color: var(--ezClockerInfoYellow);
  color: var(--ezClockerBlack);
  border-style: solid;
  border-color: var(--ezDarkYellow);
  border-width: 1px;
}

/* DEPRECATED */
.ezCell {
  padding: 4px;
  background-color: transparent;
  color: var(--ezFontColor);
  font-size: var(--ezFontSize);
  font-weight: var(--ezFontWeight);
  font-style: var(--ezFontStyle);
  border-style: solid;
  border-color: var(--ezClockerGray);
  border-width: 1px;
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-layout-grid.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,2BAAA;EACA,wCAAA;AAAJ;;AAIA;;qEAAA;AAGA;EACI,YAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;AADJ;;AAIA;EACI,uCAAA;EACA,4BAAA;AADJ;;AAIA;EACI,eAAA;EACA,MAAA;EACA,WAAA;AADJ;;AAIA;EACI,aAAA;EACA,oBAAA;EACA,+BAAA;EACA,iCAAA;EACA,gDAAA;EACA,6CAAA;EACA,0CAAA;EACA,gCAAA;EACA,mCAAA;EACA,gCAAA;EACA,uCAAA;EACA,qCAAA;AADJ;;AAIA;EACI,aAAA;EACA,oBAAA;EACA,+BAAA;EACA,iCAAA;EACA,gDAAA;EACA,6CAAA;EACA,0CAAA;EACA,gCAAA;EACA,mCAAA;EACA,gCAAA;EACA,uCAAA;EACA,qCAAA;EACA,gBAAA;AADJ;;AAIA;EACI,aAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,6BAAA;AADJ;;AAIA;EACI,aAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,6BAAA;EACA,gBAAA;AADJ;;AAIA;EACI,aAAA;EACA,oBAAA;EACA,2BAAA;EACA,6BAAA;EACA,gBAAA;AADJ;;AAIA;EACI,aAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,2BAAA;EACA,6BAAA;EACA,gBAAA;AADJ;;AAIA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,6BAAA;EACA,cAAA;AADJ;;AAIA;EACI,SAAA;EACA,UAAA;EACA,6BAAA;AADJ;;AAIA;EACI,SAAA;EACA,UAAA;EACA,6BAAA;EACA,kBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,aAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;AADJ;;AAIA;EACI,SAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,aAAA;EACA,YAAA;EACA,sBAAA;EACA,wBAAA;EACA,uCAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,uCAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,YAAA;EACA,uCAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,YAAA;EACA,uCAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;EACA,kBAAA;AADJ;;AAIA;EACI,uCAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,6BAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AADJ;;AAIA;;;CAAA;AAIA;EACI,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,2BAAA;EACA,wBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AADJ;;AAIA;;;CAAA;AAIA;EACI,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,2BAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AADJ;;AAIA;;qEAAA;AAGA;EACI,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,2BAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;EACA,gDAAA;AADJ;;AAKA;;qEAAA;AAGA;EACI,aAAA;EACA,WAAA;EACA,YAAA;AAFJ;;AAKA;EACI,aAAA;EACA,yBAAA;EACA,gCAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;AAFJ;;AAKA;EACI,aAAA;EACA,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;AAFJ;;AAKA;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,sCAAA;EACA,mCAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,YAAA;EACA,gCAAA;EACA,gCAAA;EACA,mCAAA;EACA,uCAAA;EACA,qCAAA;AAFJ;;AAKA;EACI,aAAA;EACA,YAAA;AAFJ;;AAKA;EACI,aAAA;EACA,uCAAA;EACA,wBAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,YAAA;EACA,uCAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,uCAAA;EACA,4BAAA;EACA,mCAAA;AAFJ;;AAKA;EACI,aAAA;EACA,wBAAA;EACA,wBAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,4BAAA;EACA,gCAAA;EACA,mCAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;AAFJ;;AAMA;;qEAAA;AAGA;EACI,aAAA;EACA,eAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,iBAAA;EACA,oBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,iBAAA;EACA,oBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,iBAAA;EACA,oBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,iBAAA;EACA,oBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,kBAAA;EACA,qBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,oBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,oBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,oBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,eAAA;AAHJ;;AAMA;EACI,aAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,eAAA;AAHJ;;AAOA;;qEAAA;AAGA;EACI,gCAAA;EACA,gCAAA;EACA,mCAAA;EACA,uCAAA;EACA,qCAAA;AAJJ;;AAOA;EACI,yBAAA;EACA,gCAAA;EACA,gCAAA;EACA,8BAAA;EACA,kDAAA;AAJJ;;AAOA;EACI,yBAAA;EACA,gCAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;AAJJ;;AAOA;EACI,4BAAA;EACA,gCAAA;EACA,iCAAA;EACA,qCAAA;EACA,mCAAA;AAJJ;;AAQA;;qEAAA;AAGA;EACI,uCAAA;EACA,gCAAA;EACA,kBAAA;AALJ;;AAQA;EACI,uCAAA;EACA,4BAAA;EACA,kBAAA;AALJ;;AAQA;EACI,+BAAA;EACA,sCAAA;EACA,kBAAA;AALJ;;AAQA;EACI,+BAAA;EACA,iCAAA;EACA,kBAAA;AALJ;;AAQA;EACI,uCAAA;EACA,gCAAA;EACA,kBAAA;AALJ;;AAQA;EACI,iCAAA;EACA,kCAAA;EACA,kBAAA;AALJ;;AASA;;qEAAA;AAGA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;AANJ;;AASA;EACI,aAAA;EACA,WAAA;EACA,uBAAA;AANJ;;AASA;EACI,aAAA;EACA,WAAA;EACA,oBAAA;AANJ;;AASA;EACI,aAAA;EACA,WAAA;EACA,wBAAA;AANJ;;AASA;EACI,aAAA;EACA,WAAA;EACA,8BAAA;AANJ;;AASA;EACI,aAAA;EACA,WAAA;EACA,6BAAA;AANJ;;AASA;EACI,aAAA;EACA,WAAA;EACA,6BAAA;AANJ;;AAUA;;qEAAA;AAGA;EACI,aAAA;EACA,WAAA;EACA,oBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,WAAA;EACA,qBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,WAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,WAAA;EACA,2BAAA;AAPJ;;AAUA;EACI,aAAA;EACA,WAAA;EACA,4BAAA;AAPJ;;AAWA;;qEAAA;AAGA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,wBAAA;AARJ;;AAWA;EACI,aAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,sBAAA;AARJ;;AAWA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,wBAAA;AARJ;;AAWA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,uBAAA;AARJ;;AAWA;EACI,aAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;EACA,sBAAA;AARJ;;AAWA;EACI,aAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;EACA,oBAAA;AARJ;;AAWA;EACI,aAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;EACA,uBAAA;AARJ;;AAWA;EACI,aAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,8BAAA;AARJ;;AAWA;EACI,aAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;EACA,6BAAA;AARJ;;AAWA;;qEAAA;AAGA;EACI,aAAA;EACA,gBAAA;AARJ;;AAWA;EACI,aAAA;EACA,gBAAA;AARJ;;AAWA;;qEAAA;AAGA;EACI,aAAA;EACA,gBAAA;AARJ;;AAWA;EACI,aAAA;EACA,gBAAA;AARJ;;AAWA;EACI,aAAA;EACA,gBAAA;AARJ;;AAWA;;qEAAA;AAGA;EACI,aAAA;EACA,gBAAA;AARJ;;AAWA;EACI,aAAA;EACA,gBAAA;AARJ;;AAWA;EACI,aAAA;EACA,gBAAA;AARJ;;AAWA;EACI,aAAA;EACA,gBAAA;AARJ;;AAWA;;qEAAA;AAGA;EACI,aAAA;EACA,wBAAA;AARJ;;AAWA;EACI,aAAA;EACA,+BAAA;AARJ;;AAWA;EACI,aAAA;EACA,wBAAA;AARJ;;AAWA;;qEAAA;AAGA;EACI,aAAA;EACA,2CAAA;AARJ;;AAWA;EACI,aAAA;EACA,oCAAA;AARJ;;AAWA;;EAEI,aAAA;EACA,2CAAA;AARJ;;AAWA;EACI,aAAA;EACA,kCAAA;AARJ;;AAWA;EACI,aAAA;EACA,2CAAA;AARJ;;AAWA;EACI,aAAA;EACA,oCAAA;AARJ;;AAWA;EACI,aAAA;EACA,oCAAA;AARJ;;AAWA;;EAEI,aAAA;EACA,6BAAA;AARJ;;AAWA;EACI,aAAA;EACA,4BAAA;AARJ;;AAWA;EACI,aAAA;EACA,4BAAA;AARJ;;AAWA;;EAEI,aAAA;EACA,2BAAA;AARJ;;AAWA;;qEAAA;AAGA;EACI,aAAA;EACA,uDAAA;AARJ;;AAWA;EACI,aAAA;EACA,kCAAA;AARJ;;AAWA;EACI,aAAA;EACA,gCAAA;AARJ;;AAWA;EACI,aAAA;EACA,+BAAA;AARJ;;AAWA;EACI,aAAA;EACA,gCAAA;AARJ;;AAWA;EACI,aAAA;EACA,gCAAA;AARJ;;AAWA;EACI,aAAA;EACA,gCAAA;AARJ;;AAWA;EACI,aAAA;EACA,+BAAA;AARJ;;AAWA;EACI,aAAA;EACA,gCAAA;AARJ;;AAWA;EACI,aAAA;EACA,gCAAA;AARJ;;AAWA;EACI,aAAA;EACA,+BAAA;AARJ;;AAWA;EACI,aAAA;EACA,kDAAA;AARJ;;AAWA;;qEAAA;AAGA;EACI,aAAA;EACA,uCAAA;AARJ;;AAWA;;qEAAA;AAGA;EACI,aAAA;EACA,4CAAA;AARJ;;AAWA;;qEAAA;AAGA;EACI,aAAA;EACA,2BAAA;AARJ;;AAWA;EACI,aAAA;EACA,2BAAA;AARJ;;AAWA;EACI,aAAA;EACA,0BAAA;AARJ;;AAYA;;qEAAA;AAGA;EACI,wCAAA;AATJ;;AAYA;EACI,aAAA;EACA,uCAAA;AATJ;;AAYA;EACI,aAAA;EACA,uCAAA;AATJ;;AAYA;EACI,aAAA;EACA,uCAAA;AATJ;;AAYA;EACI,aAAA;EACA,8CAAA;AATJ;;AAYA;EACI,aAAA;EACA,8CAAA;AATJ;;AAYA;EACI,aAAA;EACA,8CAAA;AATJ;;AAYA;EACI,aAAA;EACA,8CAAA;AATJ;;AAYA;EACI,aAAA;EACA,gCAAA;AATJ;;AAYA;EACI,aAAA;EACA,+BAAA;AATJ;;AAYA;EACI,aAAA;EACA,+BAAA;AATJ;;AAYA;EACI,aAAA;EACA,+BAAA;AATJ;;AAYA;EACI,aAAA;EACA,8BAAA;AATJ;;AAYA;EACI,aAAA;EACA,iCAAA;AATJ;;AAYA;EACI,aAAA;EACA,+BAAA;AATJ;;AAYA;EACI,aAAA;EACA,+BAAA;AATJ;;AAYA;EACI,aAAA;EACA,+BAAA;AATJ;;AAYA;EACI,aAAA;EACA,+BAAA;AATJ;;AAYA;EACI,aAAA;EACA,+BAAA;AATJ;;AAaA;;qEAAA;AAGA;EACI,aAAA;EACA,qCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,0DAAA;AAVJ;;AAaA;EACI,aAAA;EACA,4CAAA;AAVJ;;AAaA;EACI,aAAA;EACA,qCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,mCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,mCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,mCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,mCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,mCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,mCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,kCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,mCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,mCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,mCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,oCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,oCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,oCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,qCAAA;AAVJ;;AAaA;;qEAAA;AAGA;EACI,aAAA;EACA,0CAAA;AAVJ;;AAaA;EACI,aAAA;EACA,wCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,uCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,wCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,yCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,wCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,iDAAA;AAVJ;;AAaA;;qEAAA;AAGA;EACI,aAAA;EACA,+CAAA;AAVJ;;AAaA,iBAAA;AACA;EACI,aAAA;EACA,oBAAA;EACA,kBAAA;AAVJ;;AAaA;EACI,aAAA;EACA,oBAAA;EACA,kBAAA;AAVJ;;AAaA;EACI,aAAA;EACA,oBAAA;EACA,kBAAA;AAVJ;;AAaA;;qEAAA;AAGA;EACI,aAAA;EACA,8BAAA;EACA,2BAAA;AAVJ;;AAaA;EACI,aAAA;EACA,2BAAA;AAVJ;;AAaA;EACI,aAAA;EACA,8BAAA;AAVJ;;AAaA,qBAAA;AACA;EACI,aAAA;EACA,kBAAA;EACA,aAAA;AAVJ;;AAaA;;qEAAA;AAGA;EACI,aAAA;EACA,oBAAA;EACA,eAAA;AAVJ;;AAaA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;;;;qEAAA;AAOA;;;CAAA;AAKA;;qEAAA;AAIA,eAAA;AACA;EACI,gBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,mBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,gBAAA;EACA,mBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,iBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,kBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,iBAAA;EACA,kBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,YAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,gBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,mBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,gBAAA;EACA,mBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,iBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,kBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,iBAAA;EACA,kBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,gBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,mBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,gBAAA;EACA,mBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,iBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,kBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,iBAAA;EACA,kBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,gBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,mBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,gBAAA;EACA,mBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,iBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,kBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,iBAAA;EACA,kBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,iBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,oBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,iBAAA;EACA,oBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,kBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,mBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,kBAAA;EACA,mBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,WAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,eAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,kBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,eAAA;EACA,kBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,gBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,iBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,gBAAA;EACA,iBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,WAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,eAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,kBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,eAAA;EACA,kBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,gBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,iBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,gBAAA;EACA,iBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,WAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,eAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,kBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,eAAA;EACA,kBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,gBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,iBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,gBAAA;EACA,iBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,YAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,gBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,mBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,gBAAA;EACA,mBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,iBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,kBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,iBAAA;EACA,kBAAA;AAdJ;;AAiBA;;qEAAA;AAGA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,kCAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,mCAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,0BAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,mCAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,mCAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,0BAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,mCAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,mCAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,0BAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,mCAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,mCAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,2BAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,qBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,YAAA;EACA,YAAA;EACA,SAAA;EACA,wCAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,iBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,sBAAA;EACA,iBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,YAAA;EACA,4CAAA;EACA,4BAAA;EACA,mBAAA;EACA,iCAAA;EACA,iBAAA;AAdJ;;AAiBA,eAAA;AACA;EACI,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;EACA,mBAAA;EACA,kCAAA;EACA,iBAAA;AAdJ","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| EzClocker Grid Layout UX CSS Classes\r\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n\r\n:root {\r\n    /* ezClocker Font Famlies */\r\n    --ezLayoutGrid-row-label-font-size: 12pt;\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Page Grid Layout Styles\r\n------------------------------------------------------------------- */\r\n.ezHtml {\r\n    width: 100vw;\r\n    height: 100vh;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.ezPageHeader {\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerBlack);\r\n}\r\n\r\n.ezFixedPageHeader {\r\n    position: fixed;\r\n    top: 0;\r\n    width: 100%;\r\n}\r\n\r\n.ezPageBody {\r\n    display: grid;\r\n    align-content: start;\r\n    margin: var(--ezBodyMarginSize);\r\n    padding: var(--ezBodyPaddingSize);\r\n    background-color: var(--ezAlphaBackgroundWhite1);\r\n    background-size: var(--ezBackgroundImageSize);\r\n    background-image: var(--ezBackgroundImage);\r\n    color: var(--ezContentFontColor);\r\n    font-size: var(--ezContentFontSize);\r\n    font-family: var(--ezFontFamily);\r\n    font-weight: var(--ezContentFontWeight);\r\n    font-style: var(--ezContentFontStyle);\r\n}\r\n\r\n.ezPageBody-no-scroll {\r\n    display: grid;\r\n    align-content: start;\r\n    margin: var(--ezBodyMarginSize);\r\n    padding: var(--ezBodyPaddingSize);\r\n    background-color: var(--ezAlphaBackgroundWhite1);\r\n    background-size: var(--ezBackgroundImageSize);\r\n    background-image: var(--ezBackgroundImage);\r\n    color: var(--ezContentFontColor);\r\n    font-size: var(--ezContentFontSize);\r\n    font-family: var(--ezFontFamily);\r\n    font-weight: var(--ezContentFontWeight);\r\n    font-style: var(--ezContentFontStyle);\r\n    overflow: hidden;\r\n}\r\n\r\n.ezPageView {\r\n    display: grid;\r\n    margin: 0;\r\n    padding: 0;\r\n    align-content: start;\r\n    background-color: transparent;\r\n}\r\n\r\n.ezPageView-no-scroll {\r\n    display: grid;\r\n    margin: 0;\r\n    padding: 0;\r\n    align-content: start;\r\n    background-color: transparent;\r\n    overflow: hidden;\r\n}\r\n\r\n.ezPageViewHeader {\r\n    display: grid;\r\n    align-content: start;\r\n    grid-template-columns: 100%;\r\n    background-color: transparent;\r\n    overflow: hidden;\r\n}\r\n\r\n.ezPageSection {\r\n    display: grid;\r\n    padding: 0;\r\n    margin: 0;\r\n    align-content: start;\r\n    grid-template-columns: 100%;\r\n    background-color: transparent;\r\n    overflow: hidden;\r\n}\r\n\r\n.ezContentView {\r\n    margin-top: 4px;\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n    padding: 0;\r\n    background-color: transparent;\r\n    overflow: auto;\r\n}\r\n\r\n.ezContentSection {\r\n    margin: 0;\r\n    padding: 0;\r\n    background-color: transparent;\r\n}\r\n\r\n.ezContentSection-vertical-scroll {\r\n    margin: 0;\r\n    padding: 0;\r\n    background-color: transparent;\r\n    overflow-y: scroll;\r\n    overflow-x: hidden;\r\n}\r\n\r\n.ezContent-grid-col-section-50x50 {\r\n    display: grid;\r\n    margin: 0;\r\n    padding: 0;\r\n    grid-row-gap: 0;\r\n    grid-column-gap: 4px;\r\n    grid-template-columns: 50% 50%;\r\n    background-color: transparent;\r\n}\r\n\r\n.ezContentSection-inset-border-2-radius-bottom-pad4-vscroll {\r\n    margin: 0;\r\n    padding: 4px;\r\n    background-color: transparent;\r\n    overflow-y: scroll;\r\n    overflow-x: hidden;\r\n    border-color: var(--ezClockerBlack);\r\n    border-style: solid;\r\n    border-width: 2px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezSubContentView {\r\n    display: grid;\r\n    padding: 8px;\r\n    align-content: stretch;\r\n    justify-content: stretch;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezFontColor);\r\n    font-size: var(--ezFontSize);\r\n    font-weight: var(--ezFontWeight);\r\n    font-style: var(--ezFontStyle);\r\n    border-color: var(--ezClockerSilver);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezSubContentView-no-scroll {\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezFontColor);\r\n    font-size: var(--ezFontSize);\r\n    font-weight: var(--ezFontWeight);\r\n    font-style: var(--ezFontStyle);\r\n    border-color: var(--ezClockerSilver);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n    overflow: hidden;\r\n}\r\n\r\n.ezSubContentView_vertical {\r\n    padding: 8px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezFontColor);\r\n    font-size: var(--ezFontSize);\r\n    font-weight: var(--ezFontWeight);\r\n    font-style: var(--ezFontStyle);\r\n    border-color: var(--ezClockerSilver);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezSubContentView-no-border {\r\n    padding: 8px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezFontColor);\r\n    font-size: var(--ezFontSize);\r\n    font-weight: var(--ezFontWeight);\r\n    font-style: var(--ezFontStyle);\r\n    border-style: none;\r\n}\r\n\r\n.ezSubContentView-no-border-no-scroll {\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezFontColor);\r\n    font-size: var(--ezFontSize);\r\n    font-weight: var(--ezFontWeight);\r\n    font-style: var(--ezFontStyle);\r\n    border-style: none;\r\n    overflow: hidden;\r\n}\r\n\r\n.ezSubContentView-transparent-no-border-no-scroll {\r\n    background-color: transparent;\r\n    color: var(--ezFontColor);\r\n    font-size: var(--ezFontSize);\r\n    font-weight: var(--ezFontWeight);\r\n    font-style: var(--ezFontStyle);\r\n    border-style: none;\r\n    overflow: hidden;\r\n}\r\n\r\n/*\r\n    @deprecated\r\n    Migrate to ezHtml, ezPageBody, ezPageView functionality\r\n*/\r\n.ezPage {\r\n    display: grid;\r\n    align-content: stretch;\r\n    justify-content: stretch;\r\n    grid-template-columns: auto;\r\n    grid-template-rows: auto;\r\n    margin: 0;\r\n    padding: 0;\r\n    overflow: hidden;\r\n}\r\n\r\n/*\r\n    @deprecated\r\n    Migrate to ezHtml, ezPageBody, ezPageView, ezPageContent functionality\r\n*/\r\n.ezContent {\r\n    display: grid;\r\n    align-content: stretch;\r\n    justify-content: stretch;\r\n    grid-template-columns: auto;\r\n    grid-template-rows: auto;\r\n    margin-top: 4px;\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n    padding: 0;\r\n    overflow: scroll;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Specific Grid Styles\r\n------------------------------------------------------------------- */\r\n.ezTimeEntryGridContainer {\r\n    display: grid;\r\n    align-content: stretch;\r\n    justify-content: stretch;\r\n    grid-template-columns: auto;\r\n    grid-template-rows: auto;\r\n    padding: 8px;\r\n    margin-top: 10px;\r\n    background-color: var(--ezAlphaBackgroundWhite2);\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Generic Top Level Grid Styles\r\n------------------------------------------------------------------- */\r\n.ezFullScreen {\r\n    display: grid;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.ezGridX {\r\n    display: grid;\r\n    color: var(--ezFontColor);\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezFontSize);\r\n    font-weight: var(--ezFontWeight);\r\n    font-style: var(--ezFontStyle);\r\n}\r\n\r\n.ezGridHeader {\r\n    display: grid;\r\n    padding: 6px;\r\n    color: var(--ezTopicFontColor);\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezTopicFontSize);\r\n    font-weight: var(--ezTopicFontWeight);\r\n    font-style: var(--ezTopicFontStyle);\r\n}\r\n\r\n.ezGridHeader-navy {\r\n    display: grid;\r\n    justify-content: start;\r\n    align-content: center;\r\n    background-color: var(--ezClockerNavy);\r\n    color: var(--ezTopicFontColorWhite);\r\n    font-size: var(--ezTopicFontSize);\r\n    font-weight: var(--ezTopicFontWeight);\r\n    font-style: var(--ezTopicFontStyle);\r\n    border-color: var(--ezBorderNavy);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\n.ezGridContent {\r\n    display: grid;\r\n    padding: 4px;\r\n    color: var(--ezContentFontColor);\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezContentFontSize);\r\n    font-weight: var(--ezContentFontWeight);\r\n    font-style: var(--ezContentFontStyle);\r\n}\r\n\r\n.ezGridFullPage {\r\n    display: grid;\r\n    height: 100%;\r\n}\r\n\r\n.ezRowItem-container_2Col {\r\n    display: grid;\r\n    grid-template-columns: max-content auto;\r\n    justify-content: stretch;\r\n    align-content: center;\r\n    grid-column-gap: 4px;\r\n    grid-row-gap: 0;\r\n    padding: 8px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezFontColor);\r\n    font-size: var(--ezFontSize);\r\n    font-weight: var(--ezFontWeight);\r\n    font-style: var(--ezTopicFontStyle);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 2px;\r\n}\r\n\r\n.ezRowItem-container-disabled_2Col {\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerStone);\r\n    border-color: var(--ezClockerStone);\r\n}\r\n\r\n.ezRowItem-container-archived_2Col {\r\n    display: grid;\r\n    grid-template-rows: none;\r\n    justify-content: stretch;\r\n    align-content: center;\r\n    grid-column-gap: 4px;\r\n    grid-row-gap: 0;\r\n    padding: 8px;\r\n    background-color: var(--ezClockerGray);\r\n    color: var(--ezClockerWhite);\r\n    font-size: var(--ezFontSize);\r\n    font-weight: var(--ezFontWeight);\r\n    font-style: var(--ezTopicFontStyle);\r\n    border-color: var(--ezBorderGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\n.ezRowItem-text_col-1of2 {\r\n    display: grid;\r\n    grid-column: 1/2;\r\n    grid-row: 1;\r\n    justify-content: start;\r\n    align-content: center;\r\n}\r\n\r\n.ezRowItem-button-container_col-2of2 {\r\n    display: grid;\r\n    grid-template-columns: auto auto;\r\n    grid-column: 2/2;\r\n    grid-row: 1;\r\n    justify-content: end;\r\n    align-content: center;\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Grid Row and Column Gap Styles\r\n------------------------------------------------------------------- */\r\n.ezGridNoGap {\r\n    display: grid;\r\n    grid-row-gap: 0;\r\n    grid-column-gap: 0;\r\n}\r\n\r\n.ezGridGap {\r\n    display: grid;\r\n    grid-row-gap: 2px;\r\n    grid-column-gap: 2px;\r\n}\r\n\r\n.ezGridGap_2 {\r\n    display: grid;\r\n    grid-row-gap: 2px;\r\n    grid-column-gap: 2px;\r\n}\r\n\r\n.ezGridGap_4 {\r\n    display: grid;\r\n    grid-row-gap: 4px;\r\n    grid-column-gap: 4px;\r\n}\r\n\r\n.ezGridGap_8 {\r\n    display: grid;\r\n    grid-row-gap: 8px;\r\n    grid-column-gap: 8px;\r\n}\r\n\r\n.ezGridGap_20 {\r\n    display: grid;\r\n    grid-row-gap: 20px;\r\n    grid-column-gap: 20px;\r\n}\r\n\r\n.ezGrid-col-gap-4 {\r\n    display: grid;\r\n    grid-column-gap: 4px;\r\n}\r\n\r\n.ezGrid-col-gap_6 {\r\n    display: grid;\r\n    grid-column-gap: 6px;\r\n}\r\n\r\n.ezGrid-col-gap_8 {\r\n    display: grid;\r\n    grid-column-gap: 8px;\r\n}\r\n\r\n.ezGrid-no-row-gap {\r\n    display: grid;\r\n    grid-row-gap: 0;\r\n}\r\n\r\n.ezGrid-row-gap_8 {\r\n    display: grid;\r\n    grid-row-gap: 8px;\r\n}\r\n\r\n.ezGrid-row-gap_10 {\r\n    display: grid;\r\n    grid-row-gap: 10px;\r\n}\r\n\r\n.ezGrid-row-gap-0 {\r\n    display: grid;\r\n    grid-row-gap: 0;\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Grid Text Styles\r\n------------------------------------------------------------------- */\r\n.ezGridContentText {\r\n    color: var(--ezContentFontColor);\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezContentFontSize);\r\n    font-weight: var(--ezContentFontWeight);\r\n    font-style: var(--ezContentFontStyle);\r\n}\r\n\r\n.ezGridRowLabelText {\r\n    color: var(--ezFontColor);\r\n    font-family: var(--ezFontFamily);\r\n    font-weight: var(--ezFontWeight);\r\n    font-style: var(--ezFontStyle);\r\n    font-size: var(--ezLayoutGrid-row-label-font-size);\r\n}\r\n\r\n.ezGridNormalText {\r\n    color: var(--ezFontColor);\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezFontSize);\r\n    font-weight: var(--ezFontWeight);\r\n    font-style: var(--ezFontStyle);\r\n}\r\n\r\n.ezGridTopicText {\r\n    color: var(--ezClockerWhite);\r\n    font-family: var(--ezFontFamily);\r\n    font-size: var(--ezTopicFontSize);\r\n    font-weight: var(--ezTopicFontWeight);\r\n    font-style: var(--ezTopicFontStyle);\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Grid Background Styles\r\n------------------------------------------------------------------- */\r\n.ezGridWhite {\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezContentFontColor);\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezGridBlack {\r\n    background-color: var(--ezClockerBlack);\r\n    color: var(--ezClockerWhite);\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezGridNavy {\r\n    background-color: var(--ezNavy);\r\n    color: var(--ezNavyContainerTextColor);\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezGridGray {\r\n    background-color: var(--ezGray);\r\n    color: var(--ezGrayContainerText);\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezGridStone {\r\n    background-color: var(--ezClockerStone);\r\n    color: var(--ezContentFontColor);\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezGridYellow {\r\n    background-color: var(--ezYellow);\r\n    color: var(--ezYelloContainerText);\r\n    border-radius: 3px;\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Grid Horizontal Alignment Styles (X-Axis)\r\n------------------------------------------------------------------- */\r\n.ezGrid-align-left {\r\n    display: grid;\r\n    /* X-Axis */\r\n    justify-content: start;\r\n}\r\n\r\n.ezGrid-align-center {\r\n    display: grid;\r\n    /* X-Axis */\r\n    justify-content: center;\r\n}\r\n\r\n.ezGrid-align-right {\r\n    display: grid;\r\n    /* X-Axis */\r\n    justify-content: end;\r\n}\r\n\r\n.ezGrid-align-full {\r\n    display: grid;\r\n    /* X-Axis */\r\n    justify-content: stretch;\r\n}\r\n\r\n.ezGrid-align-space-between {\r\n    display: grid;\r\n    /* X-Axis */\r\n    justify-content: space-between;\r\n}\r\n\r\n.ezGrid-align-space-around {\r\n    display: grid;\r\n    /* X-Axis */\r\n    justify-content: space-around;\r\n}\r\n\r\n.ezGrid-align-space-evenly {\r\n    display: grid;\r\n    /* X-Axis */\r\n    justify-content: space-evenly;\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Grid Vertical Alignment Styles (Y-Axis)\r\n------------------------------------------------------------------- */\r\n.ezGrid-vertical-align-top {\r\n    display: grid;\r\n    /* Y-Axis */\r\n    align-content: start;\r\n}\r\n\r\n.ezGrid-vertical-align-middle {\r\n    display: grid;\r\n    /* Y-Axis */\r\n    align-content: center;\r\n}\r\n\r\n.ezGrid-vertical-align-bottom {\r\n    display: grid;\r\n    /* Y-Axis */\r\n    align-content: end;\r\n}\r\n\r\n.ezGrid-vertical-align-full {\r\n    display: grid;\r\n    /* Y-Axis */\r\n    align-content: stretch;\r\n}\r\n\r\n.ezGrid-vertical-space-evenly {\r\n    display: grid;\r\n    /* Y-Axis */\r\n    align-content: space-evenly;\r\n}\r\n\r\n.ezGrid-vertical-space-between {\r\n    display: grid;\r\n    /* Y-Axis */\r\n    align-content: space-between;\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Grid Vertical and Horizontal Alignment Styles\r\n------------------------------------------------------------------- */\r\n.ezGrid-fullsize {\r\n    display: grid;\r\n    /* X-Axis */\r\n    align-content: stretch;\r\n    /* Y-Axis */\r\n    justify-content: stretch;\r\n}\r\n\r\n.ezGrid-align-top-left {\r\n    display: grid;\r\n    /* X-Axis */\r\n    align-content: start;\r\n    /* Y-Axis */\r\n    justify-content: start;\r\n}\r\n\r\n.ezGrid-align-fullsize {\r\n    display: grid;\r\n    /* X-Axis */\r\n    align-content: stretch;\r\n    /* Y-Axis */\r\n    justify-content: stretch;\r\n}\r\n\r\n.ezGrid-align-middle-full-width {\r\n    display: grid;\r\n    /* X-Axis */\r\n    align-content: stretch;\r\n    /* Y-Axis */\r\n    justify-content: center;\r\n}\r\n\r\n.ezGrid-align-middle-left {\r\n    display: grid;\r\n    /* X-Axis */\r\n    align-content: center;\r\n    /* Y-Axis */\r\n    justify-content: start;\r\n}\r\n\r\n.ezGrid-align-middle-right {\r\n    display: grid;\r\n    /* X-Axis */\r\n    align-content: center;\r\n    /* Y-Axis */\r\n    justify-content: end;\r\n}\r\n\r\n.ezGrid-align-middle-center {\r\n    display: grid;\r\n    /* X-Axis */\r\n    align-content: center;\r\n    /* Y-Axis */\r\n    justify-content: center;\r\n}\r\n\r\n.ezGrid-align-top-space-evenly {\r\n    display: grid;\r\n    /* X-Axis */\r\n    align-content: start;\r\n    /* Y-Axis */\r\n    justify-content: space-between;\r\n}\r\n\r\n.ezGrid-x-space-between-y-stretch {\r\n    display: grid;\r\n    /* X-Axis */\r\n    align-content: center;\r\n    /* Y-Axis */\r\n    justify-content: space-evenly;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Columns Classes for 2 Column Grids\r\n------------------------------------------------------------------- */\r\n.ezCol-1of2 {\r\n    display: grid;\r\n    grid-column: 1/2;\r\n}\r\n\r\n.ezCol-2of2 {\r\n    display: grid;\r\n    grid-column: 2/2;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Columns Classes for 3 Column Grids\r\n------------------------------------------------------------------- */\r\n.ezCol-1of3 {\r\n    display: grid;\r\n    grid-column: 1/2;\r\n}\r\n\r\n.ezCol-2of3 {\r\n    display: grid;\r\n    grid-column: 2/2;\r\n}\r\n\r\n.ezCol-3of3 {\r\n    display: grid;\r\n    grid-column: 3/3;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Columns Classes for 4 Column Grids\r\n------------------------------------------------------------------- */\r\n.ezCol-1of4 {\r\n    display: grid;\r\n    grid-column: 1/4;\r\n}\r\n\r\n.ezCol-2of4 {\r\n    display: grid;\r\n    grid-column: 2/4;\r\n}\r\n\r\n.ezCol-3of4 {\r\n    display: grid;\r\n    grid-column: 3/4;\r\n}\r\n\r\n.ezCol-4of4 {\r\n    display: grid;\r\n    grid-column: 3/4;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Generic Row Grid Styles\r\n------------------------------------------------------------------- */\r\n.ezAutoRow {\r\n    display: grid;\r\n    grid-template-rows: auto;\r\n}\r\n\r\n.ezAutoRow_Min {\r\n    display: grid;\r\n    grid-template-rows: min-content;\r\n}\r\n\r\n.ezAutoRow_100 {\r\n    display: grid;\r\n    grid-template-rows: 100%;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Two Row Grid Styles\r\n------------------------------------------------------------------- */\r\n.ezAutoRow_Min_2 {\r\n    display: grid;\r\n    grid-template-rows: min-content min-content;\r\n}\r\n\r\n.ezAutoRow_Min_Auto {\r\n    display: grid;\r\n    grid-template-rows: min-content auto;\r\n}\r\n\r\n.ezAutoRow_MinxMax,\r\n.ezAutoRow_Min_Max {\r\n    display: grid;\r\n    grid-template-rows: min-content max-content;\r\n}\r\n\r\n.ezAutoRow_600px_600px {\r\n    display: grid;\r\n    grid-template-columns: 600px 600px;\r\n}\r\n\r\n.ezAutoRow_Min_Min {\r\n    display: grid;\r\n    grid-template-rows: min-content min-content;\r\n}\r\n\r\n.ezAutoRow_A_Max {\r\n    display: grid;\r\n    grid-template-rows: auto max-content;\r\n}\r\n\r\n.ezAutoRow_A_min {\r\n    display: grid;\r\n    grid-template-rows: auto min-content;\r\n}\r\n\r\n.ezAutoRow_AxA,\r\n.ezAutoRow_A_A {\r\n    display: grid;\r\n    grid-template-rows: auto auto;\r\n}\r\n\r\n.ezAutoRow_50_A {\r\n    display: grid;\r\n    grid-template-rows: 50% auto;\r\n}\r\n\r\n.ezAutoRow_A_50 {\r\n    display: grid;\r\n    grid-template-rows: auto 50%;\r\n}\r\n\r\n.ezAutoRow_50x50,\r\n.ezAutoRow_50_50 {\r\n    display: grid;\r\n    grid-template-rows: 50% 50%;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Three Row Grid Styles\r\n------------------------------------------------------------------- */\r\n.ezAutoRow_Min_3 {\r\n    display: grid;\r\n    grid-template-rows: min-content min-content min-content;\r\n}\r\n\r\n.ezAutoRow_A_A_A {\r\n    display: grid;\r\n    grid-template-rows: auto auto auto;\r\n}\r\n\r\n.ezAutoRow_33_A_33 {\r\n    display: grid;\r\n    grid-template-rows: 33% auto 33%;\r\n}\r\n\r\n.ezAutoRow_33_33_33 {\r\n    display: grid;\r\n    grid-template-rows: 33% 33% 33%;\r\n}\r\n\r\n.ezAutoRow_33_33_A {\r\n    display: grid;\r\n    grid-template-rows: 33% 33% auto;\r\n}\r\n\r\n.ezAutoRow_A_33_33 {\r\n    display: grid;\r\n    grid-template-rows: auto 33% 33%;\r\n}\r\n\r\n.ezAutoRow_25_A_25 {\r\n    display: grid;\r\n    grid-template-rows: 25% auto 25%;\r\n}\r\n\r\n.ezAutoRow_25_50_25 {\r\n    display: grid;\r\n    grid-template-rows: 25% 50% 25%;\r\n}\r\n\r\n.ezAutoRow_25_25_A {\r\n    display: grid;\r\n    grid-template-rows: 25% 25% auto;\r\n}\r\n\r\n.ezAutoRow_A_25_25 {\r\n    display: grid;\r\n    grid-template-rows: auto 25% 25%;\r\n}\r\n\r\n.ezAutoRow_1fr_2fr_1fr {\r\n    display: grid;\r\n    grid-template-rows: 1fr 2fr 1fr;\r\n}\r\n\r\n.ezAutoRow_Min_Max_A {\r\n    display: grid;\r\n    grid-template-rows: min-content, max-content, auto;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Four Row Grid Styles\r\n------------------------------------------------------------------- */\r\n.ezAutoRow_AxAxAxA {\r\n    display: grid;\r\n    grid-template-rows: auto auto auto auto;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Five Row Grid Styles\r\n------------------------------------------------------------------- */\r\n.ezAutoRow_AxAxAxAxA {\r\n    display: grid;\r\n    grid-template-rows: auto auto auto auto auto;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| One Column Grid Styles\r\n------------------------------------------------------------------- */\r\n.ezAutoCol_A {\r\n    display: grid;\r\n    grid-template-columns: auto;\r\n}\r\n\r\n.ezAutoCol_100 {\r\n    display: grid;\r\n    grid-template-columns: 100%;\r\n}\r\n\r\n.ezAutoCol_99 {\r\n    display: grid;\r\n    grid-template-columns: 99%;\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Two (TWO! HA HA HA!) Column Grid Styles\r\n------------------------------------------------------------------- */\r\n.ezAutoCol_83xA {\r\n    grid-template-columns: 83.33333333% auto;\r\n}\r\n\r\n.ezAutoCol_MinxA {\r\n    display: grid;\r\n    grid-template-columns: min-content auto;\r\n}\r\n\r\n.ezAutoCol_AxMin {\r\n    display: grid;\r\n    grid-template-columns: auto min-content;\r\n}\r\n\r\n.ezAutoCol_AxMax {\r\n    display: grid;\r\n    grid-template-columns: auto max-content;\r\n}\r\n\r\n.ezAutoCol_MinxMax {\r\n    display: grid;\r\n    grid-template-columns: min-content max-content;\r\n}\r\n\r\n.ezAutoCol_Max_Min {\r\n    display: grid;\r\n    grid-template-columns: max-content min-content;\r\n}\r\n\r\n.ezAutoCol_Max_A {\r\n    display: grid;\r\n    grid-template-columns: max-content min-content;\r\n}\r\n\r\n.ezAutoCol_Max_Max {\r\n    display: grid;\r\n    grid-template-columns: max-content max-content;\r\n}\r\n\r\n.ezAutoCol_AxA {\r\n    display: grid;\r\n    grid-template-columns: auto auto;\r\n}\r\n\r\n.ezAutoCol_50xA {\r\n    display: grid;\r\n    grid-template-columns: 50% auto;\r\n}\r\n\r\n.ezAutoCol_Ax70 {\r\n    display: grid;\r\n    grid-template-columns: auto 70%;\r\n}\r\n\r\n.ezAutoCol_Ax50 {\r\n    display: grid;\r\n    grid-template-columns: auto 50%;\r\n}\r\n\r\n.ezAutoCol_50x50 {\r\n    display: grid;\r\n    grid-template-columns: 50% 50%;\r\n}\r\n\r\n.ezAutoCol_200PXxA {\r\n    display: grid;\r\n    grid-template-columns: 200px auto;\r\n}\r\n\r\n.ezAutoCol_33xA {\r\n    display: grid;\r\n    grid-template-columns: 33% auto;\r\n}\r\n\r\n.ezAutoCol_Ax33 {\r\n    display: grid;\r\n    grid-template-columns: auto 33%;\r\n}\r\n\r\n.ezAutoCol_25xA {\r\n    display: grid;\r\n    grid-template-columns: 25% auto;\r\n}\r\n\r\n.ezAutoCol_Ax25 {\r\n    display: grid;\r\n    grid-template-columns: auto 25%;\r\n}\r\n\r\n.ezAutoCol_75xA {\r\n    display: grid;\r\n    grid-template-columns: 75% auto;\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Three (THREE! HA HA HA!) Column Grid Styles\r\n------------------------------------------------------------------- */\r\n.ezAutoCol_28px_28px_28px {\r\n    display: grid;\r\n    grid-template-columns: 28px 28px 28px;\r\n}\r\n\r\n.ezAutoCol_MinxMinxMin {\r\n    display: grid;\r\n    grid-template-columns: min-content min-content min-content;\r\n}\r\n\r\n.ezAutoCol_AxAxMin {\r\n    display: grid;\r\n    grid-template-columns: auto auto min-content;\r\n}\r\n\r\n.ezAutoCol_AxAxA {\r\n    display: grid;\r\n    grid-template-columns: auto auto auto;\r\n}\r\n\r\n.ezAutoCol_25x25xA {\r\n    display: grid;\r\n    grid-template-columns: 25% 25% auto;\r\n}\r\n\r\n.ezAutoCol_25xAx25 {\r\n    display: grid;\r\n    grid-template-columns: 25% auto 25%;\r\n}\r\n\r\n.ezAutoCol_Ax25x25 {\r\n    display: grid;\r\n    grid-template-columns: auto 25% 25%;\r\n}\r\n\r\n.ezAutoCol_33x33xA {\r\n    display: grid;\r\n    grid-template-columns: 33% 33% auto;\r\n}\r\n\r\n.ezAutoCol_33xAx33 {\r\n    display: grid;\r\n    grid-template-columns: 33% auto 33%;\r\n}\r\n\r\n.ezAutoCol_Ax33x33 {\r\n    display: grid;\r\n    grid-template-columns: auto 33% 33%;\r\n}\r\n\r\n.ezAutoCol_33x33x33 {\r\n    display: grid;\r\n    grid-template-columns: 33% 33% 33%;\r\n}\r\n\r\n.ezAutoCol_50x25xA {\r\n    display: grid;\r\n    grid-template-columns: 25% 25% auto;\r\n}\r\n\r\n.ezAutoCol_Ax50x25 {\r\n    display: grid;\r\n    grid-template-columns: auto 50% 25%;\r\n}\r\n\r\n.ezAutoCol_50xAx25 {\r\n    display: grid;\r\n    grid-template-columns: 50% auto 25%;\r\n}\r\n\r\n.ezAutoCol_50xAxA {\r\n    display: grid;\r\n    grid-template-columns: 50% auto auto;\r\n}\r\n\r\n.ezAutoCol_Ax50xA {\r\n    display: grid;\r\n    grid-template-columns: auto 50% auto;\r\n}\r\n\r\n.ezAutoCol_AxAx50 {\r\n    display: grid;\r\n    grid-template-columns: auto auto 50%;\r\n}\r\n\r\n.ezAutoCol_AxAx30px {\r\n    display: grid;\r\n    grid-template-columns: auto auto 33px;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Four (FOUR! HA HA HA!) Column Grid Styles\r\n------------------------------------------------------------------- */\r\n.ezAutoCol_AxAxAxA {\r\n    display: grid;\r\n    grid-template-columns: auto auto auto auto;\r\n}\r\n\r\n.ezAutoCol_25x25xAxA {\r\n    display: grid;\r\n    grid-template-columns: 25% 25% auto auto;\r\n}\r\n\r\n.ezAutoCol_25x25x25xA {\r\n    display: grid;\r\n    grid-template-columns: 25% 25% 25% auto;\r\n}\r\n\r\n.ezAutoCol_25xAxAx25 {\r\n    display: grid;\r\n    grid-template-columns: 25% auto auto 25%;\r\n}\r\n\r\n.ezAutoCol_AxAxAx25 {\r\n    display: grid;\r\n    grid-template-columns: auto auto auto 25%;\r\n}\r\n\r\n.ezAutoCol_10xAxAx10 {\r\n    display: grid;\r\n    grid-template-columns: 10% auto auto 10%;\r\n}\r\n\r\n.ezAutoCol_AxAxAxMax {\r\n    display: grid;\r\n    grid-template-columns: auto auto auto max-content;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Five (FIVE! MUHAHAHAHA!) Column Grid Styles\r\n------------------------------------------------------------------- */\r\n.ezAutoCol_AxAxAxAxA {\r\n    display: grid;\r\n    grid-template-columns: auto auto auto auto auto;\r\n}\r\n\r\n/* Column Spans */\r\n.ezColSpan_1a2 {\r\n    display: grid;\r\n    grid-column-start: 1;\r\n    grid-column-end: 2;\r\n}\r\n\r\n.ezColSpan_1a2a3 {\r\n    display: grid;\r\n    grid-column-start: 1;\r\n    grid-column-end: 3;\r\n}\r\n\r\n.ezColSpan_2a3 {\r\n    display: grid;\r\n    grid-column-start: 2;\r\n    grid-column-end: 3;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Sub-Grid Styles\r\n------------------------------------------------------------------- */\r\n.ezSubGridColRow {\r\n    display: grid;\r\n    grid-template-columns: subgrid;\r\n    grid-template-rows: subgrid;\r\n}\r\n\r\n.ezSubgridRow {\r\n    display: grid;\r\n    grid-template-rows: subgrid;\r\n}\r\n\r\n.ezSubGridCol {\r\n    display: grid;\r\n    grid-template-columns: subgrid;\r\n}\r\n\r\n/* Grid Column Gaps */\r\n.ezNoGridColumnGap {\r\n    display: grid;\r\n    grid-column-gap: 0;\r\n    column-gap: 0;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Grid Column Gap Styles\r\n------------------------------------------------------------------- */\r\n.ezGridColumnGap {\r\n    display: grid;\r\n    grid-column-gap: 1px;\r\n    column-gap: 1px;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 1024px) {\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 768px) {\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 480px) {\r\n}/\r\n\r\n/* -------------------------------------------------------------------\r\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 319px) {\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| DEPRECATED STYLES\r\n------------------------------------------------------------------- */\r\n\r\n/* DEPRECATED */\r\n.ezPadTop2 {\r\n    padding-top: 2px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadBottom2 {\r\n    padding-bottom: 2px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadTopBottom2 {\r\n    padding-top: 2px;\r\n    padding-bottom: 2px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadLeft2 {\r\n    padding-left: 2px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadRight2 {\r\n    padding-right: 2px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadLeftRight2 {\r\n    padding-left: 2px;\r\n    padding-right: 2px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPaddedBox4 {\r\n    padding: 4px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadTop4 {\r\n    padding-top: 4px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadBottom4 {\r\n    padding-bottom: 4px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadTopBottom4 {\r\n    padding-top: 4px;\r\n    padding-bottom: 4px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadLeft4 {\r\n    padding-left: 4px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadRight4 {\r\n    padding-right: 4px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadLeftRight4 {\r\n    padding-left: 4px;\r\n    padding-right: 4px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadTop6 {\r\n    padding-top: 6px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadBottom6 {\r\n    padding-bottom: 6px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadTopBottom6 {\r\n    padding-top: 6px;\r\n    padding-bottom: 6px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadLeft6 {\r\n    padding-left: 6px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadRight6 {\r\n    padding-right: 6px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadLeftRight6 {\r\n    padding-left: 6px;\r\n    padding-right: 6px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadTop8 {\r\n    padding-top: 8px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadBottom8 {\r\n    padding-bottom: 8px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadTopBottom8 {\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadLeft8 {\r\n    padding-left: 8px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadRight8 {\r\n    padding-right: 8px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadLeftRight8 {\r\n    padding-left: 8px;\r\n    padding-right: 8px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadTop10 {\r\n    padding-top: 10px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadBottom10 {\r\n    padding-bottom: 10px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadTopBottom10 {\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadLeft10 {\r\n    padding-left: 10px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadRight10 {\r\n    padding-right: 10px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezPadLeftRight10 {\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMargin2 {\r\n    margin: 2px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginTop2 {\r\n    margin-top: 2px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginBottom2 {\r\n    margin-bottom: 2px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginTopBottom2 {\r\n    margin-top: 2px;\r\n    margin-bottom: 2px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginLeft2 {\r\n    margin-left: 2px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginRight2 {\r\n    margin-right: 2px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginLeftRight2 {\r\n    margin-left: 2px;\r\n    margin-right: 2px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMargin4 {\r\n    margin: 4px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginTop4 {\r\n    margin-top: 4px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginBottom4 {\r\n    margin-bottom: 4px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginTopBottom4 {\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginLeft4 {\r\n    margin-left: 4px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginRight4 {\r\n    margin-right: 4px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginLeftRight4 {\r\n    margin-left: 4px;\r\n    margin-right: 4px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMargin8 {\r\n    margin: 8px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginTop8 {\r\n    margin-top: 8px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginBottom8 {\r\n    margin-bottom: 8px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginTopBottom8 {\r\n    margin-top: 8px;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginLeft8 {\r\n    margin-left: 8px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginRight8 {\r\n    margin-right: 8px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginLeftRight8 {\r\n    margin-left: 8px;\r\n    margin-right: 8px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMargin10 {\r\n    margin: 10px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginTop10 {\r\n    margin-top: 10px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginBottom10 {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginTopBottom10 {\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginLeft10 {\r\n    margin-left: 10px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginRight10 {\r\n    margin-right: 10px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezMarginLeftRight10 {\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n}\r\n\r\n/* -------------------------------------------------------------------\r\n| Legacy Auto-Column (experimental) Styles\r\n------------------------------------------------------------------- */\r\n/* DEPRECATED */\r\n.ezAutoCol1 {\r\n    display: grid;\r\n    min-height: 1px;\r\n    grid-template-columns: 8.33333333%;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezAutoCol2 {\r\n    display: grid;\r\n    min-height: 1px;\r\n    grid-template-columns: 16.66666667%;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezAutoCol3 {\r\n    display: grid;\r\n    min-height: 1px;\r\n    grid-template-columns: 25%;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezAutoCol4 {\r\n    display: grid;\r\n    min-height: 1px;\r\n    grid-template-columns: 33.33333333%;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezAutoCol5 {\r\n    display: grid;\r\n    min-height: 1px;\r\n    grid-template-columns: 41.66666667%;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezAutoCol6 {\r\n    display: grid;\r\n    min-height: 1px;\r\n    grid-template-columns: 50%;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezAutoCol7 {\r\n    display: grid;\r\n    min-height: 1px;\r\n    grid-template-columns: 58.33333333%;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezAutoCol8 {\r\n    display: grid;\r\n    min-height: 1px;\r\n    grid-template-columns: 66.66666667%;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezAutoCol9 {\r\n    display: grid;\r\n    min-height: 1px;\r\n    grid-template-columns: 75%;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezAutoCol10 {\r\n    display: grid;\r\n    min-height: 1px;\r\n    grid-template-columns: 83.33333333%;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezAutoCol11 {\r\n    display: grid;\r\n    min-height: 1px;\r\n    grid-template-columns: 91.66666667%;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezColumn12 {\r\n    display: grid;\r\n    min-height: 1px;\r\n    grid-template-columns: 100%;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezCenterBox {\r\n    display: flex;\r\n    text-align: right;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezBox {\r\n    display: inline-block;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezFooter {\r\n    padding: 4px;\r\n    height: 24px;\r\n    bottom: 0;\r\n    background-color: var(--ezClockerSilver);\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezRightAlign {\r\n    text-align: right;\r\n}\r\n\r\n/* DEPRECATED */\r\ntd.ezclockerHeader2015Right {\r\n    vertical-align: middle;\r\n    text-align: right;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezInfoBox {\r\n    padding: 4px;\r\n    background-color: var(--ezClockerInfoYellow);\r\n    color: var(--ezClockerBlack);\r\n    border-style: solid;\r\n    border-color: var(--ezDarkYellow);\r\n    border-width: 1px;\r\n}\r\n\r\n/* DEPRECATED */\r\n.ezCell {\r\n    padding: 4px;\r\n    background-color: transparent;\r\n    color: var(--ezFontColor);\r\n    font-size: var(--ezFontSize);\r\n    font-weight: var(--ezFontWeight);\r\n    font-style: var(--ezFontStyle);\r\n    border-style: solid;\r\n    border-color: var(--ezClockerGray);\r\n    border-width: 1px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
